import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column gap-1 text-align-left" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = ["href"]


export default /*@__PURE__*/_defineComponent({
  __name: 'NoAccountSection',
  setup(__props) {

const serviceUrl = process.env.VUE_APP_CUSTOMER_SERVICE_URL || '#';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('welcome.no_account')) + " ", 1),
      _createElementVNode("a", {
        class: "body",
        href: _unref(serviceUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(_ctx.$t('welcome.customer_service')), 9, _hoisted_3)
    ])
  ]))
}
}

})